export function getPpi() {
  let div = document.createElement("div");
  div.style.height = "1in";
  div.style.width = "1in";
  div.style.top = "-100%";
  div.style.left = "-100%";
  div.style.position = "absolute";
  let devicePixelRatio = window.devicePixelRatio || 1;
  document.body.appendChild(div);

  let result = div.offsetHeight * devicePixelRatio;

  document.body.removeChild(div);

  return result;
}
